<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <notifications
        classes="app-notify"
        :duration="5000"
        :width="600"
        animation-name="v-fade-left"
        position="top right"
      >
      </notifications>
      <login-card header-color="green">
        <h4 slot="title" class="title">Log in</h4>
        <!--        <md-button-->
        <!--          slot="buttons"-->
        <!--          href="#facebook"-->
        <!--          class="md-just-icon md-simple md-white"-->
        <!--          @click.prevent="loginWithFacebook"-->
        <!--        >-->
        <!--          <i class="fab fa-facebook-square"></i>-->
        <!--        </md-button>-->
        <!--        <md-button-->
        <!--          slot="buttons"-->
        <!--          href="#google"-->
        <!--          class="md-just-icon md-simple md-white"-->
        <!--          @click.prevent="loginWithGoogle"-->
        <!--        >-->
        <!--          <i class="fab fa-google-plus-g"></i>-->
        <!--        </md-button>-->
        <p slot="description" class="description"></p>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>face</md-icon>
          <label>Username</label>
          <md-input
            @keyup.enter.prevent="login"
            v-model="params.username"
          ></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>Password...</label>
          <md-input
            @keyup.enter.prevent="login"
            v-model="params.password"
            type="password"
          ></md-input>
        </md-field>
        <md-button
          slot="footer"
          class="md-simple md-success md-lg"
          @click.prevent="login"
        >
          {{ $t("user.login") }}
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import { initFbSdk } from "@/helpers/facebook_oAuth.js";
import { AuthService } from "../../../services/auth.service";
import { UserService } from "../../../services/user.service";

export default {
  components: {
    LoginCard
  },
  data() {
    return {
      params: {
        username: "",
        password: ""
      },
      onlyMember: false
    };
  },
  methods: {
    async login() {
      await AuthService.login({
        username: this.params.username,
        password: this.params.password
      });
      await this.setAuth();
    },
    loginWithGoogle() {
      this.$gAuth
        .signIn()
        .then(GoogleUser => {
          let access_token = GoogleUser.getAuthResponse().access_token;
          this.loginSocial(access_token, "google");
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    loginWithFacebook() {
      window.FB.login(response => {
        let access_token = response.authResponse.accessToken;
        this.loginSocial(access_token, "facebook");
      }, this.params);
    },
    async loginSocial(token, type) {
      await AuthService.loginSocial(token, type);
      await this.setAuth();
    },
    async setAuth() {
      await UserService.setAbility();
      if (this.onlyMember) {
        this.$notify({
          title: "Important message",
          text:
            "Bạn không có quyền sử dụng hệ thống. Vui lòng đăng nhập bằng tài khoản Admin",
          type: "error"
        });
        this.$store.commit("auth/DESTROY_AUTH");
        return;
      }
      await this.$router.push({ name: "UniversityList" });
    }
  },
  mounted() {
    initFbSdk();
  }
};
</script>

<style></style>
